module.exports = __webpack_public_path__ + "img/long-term-cache/not-found.3ce8811bc75473720f61e64235b2d741.png";